import { fileUrl } from "@/lib/api";
import { FileText, Download } from "lucide-react";

export default function Attachments({ items = [] }) {
  if (!items || items.length === 0) return null;
  const images = items.filter((a) => a.content_type !== "application/pdf");
  const docs = items.filter((a) => a.content_type === "application/pdf");

  return (
    <div className="mt-4 space-y-3" data-testid="attachments">
      {images.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {images.map((a) => (
            <a key={a.path} href={fileUrl(a.path)} target="_blank" rel="noreferrer" className="block h-24 w-24 overflow-hidden rounded-lg border border-border">
              <img src={fileUrl(a.path)} alt={a.filename} className="h-full w-full object-cover transition-transform hover:scale-105" />
            </a>
          ))}
        </div>
      )}
      {docs.map((a) => (
        <a key={a.path} href={fileUrl(a.path)} target="_blank" rel="noreferrer"
          className="flex w-fit items-center gap-2 rounded-lg border border-border bg-secondary px-3 py-2 text-sm text-ztk-navy transition-colors hover:border-ztk-blue dark:text-slate-200">
          <FileText className="h-4 w-4 text-ztk-red" />
          <span className="max-w-[240px] truncate">{a.filename}</span>
          <Download className="h-3.5 w-3.5 text-muted-foreground" />
        </a>
      ))}
    </div>
  );
}
